import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {MentalGameAssets} from "./MentalGameAssets";
import {IMentalGameData} from "./server/MentalData";
import {MentalGameMode} from "./server/MentalGameMode";
import {MentalSoundConfig} from "./MentalSoundConfig";
import {SoundManager} from "./sound/SoundManager";
import {MentalHelper} from "./utils/MentalHelper";

export class MentalPromoPanelConfig implements PromoPanelGameConfiguration{
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Mental",
            hasActionSpin: true,
            graphics: {backgroundTextureName: MentalGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: IMentalGameData, bet: number, prevResponse: IMentalGameData):ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: response.freespinTriggeredThisSpin,
                    totalSpinWinnings: response.totalBetWayWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    private isBigWin(response:IMentalGameData): boolean {
        let win = response.totalBetWayWinnings;

        if (response.wasFeatureBuy){
            const betPrice = MentalHelper.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response: IMentalGameData): string {
        if ((response.mode == MentalGameMode.STANDARD_FREESPIN) || response.nextMode == MentalGameMode.STANDARD_FREESPIN){
            return "AUTOPSY FREESPINS";
        }

        if ((response.mode == MentalGameMode.COOL_FREESPIN) || response.nextMode == MentalGameMode.COOL_FREESPIN){
            return "LOBOTOMY FREESPINS";
        }

        if ((response.mode == MentalGameMode.SUPER_FREESPIN) || response.nextMode == MentalGameMode.SUPER_FREESPIN){
            return "MENTAL FREESPINS";
        }

        return response.mode;
    }

    private isRoundComplete(response: IMentalGameData): boolean {
        return true;
    }

    private isBonusEnd(response: IMentalGameData): boolean {
        return (response.nextMode === MentalGameMode.NORMAL) && (response.nextMode === MentalGameMode.STANDARD_FREESPIN || response.nextMode === MentalGameMode.SUPER_FREESPIN || response.nextMode === MentalGameMode.COOL_FREESPIN);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            SoundManager.playSoundEffect(MentalSoundConfig.AS_WIN);
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSoundEffect(MentalSoundConfig.AS_WIN_BIG);
        }
    }

}